import { render } from "./HeroiconsSolidColorSwatch.vue?vue&type=template&id=3ba833ae"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidColorSwatch.vue"]])

export default __exports__